import { Subject } from 'rxjs';
import { Component, OnDestroy } from '@angular/core';
import { shapeLineIcon, SVGIcon } from "@progress/kendo-svg-icons";
import { Router, ActivatedRoute } from '@angular/router';
import { inject } from '@angular/core';
import { BreadCrumbService } from '../services/bread-crumb.service';
import { IBreadCrumbItem } from '../interfaces/i-breadcrumb-item.interface';
import { BreadCrumbItem } from '@progress/kendo-angular-navigation';

@Component({
    selector: 'app-base-comp',
    template: '',
    standalone: false
})
export abstract class BaseComponent implements OnDestroy {

  protected subscription: Subject<boolean>;

  breadCrumbs: BreadCrumbItem[] = [];
  bcs: IBreadCrumbItem[] = [];
  breadCrumbSeparator: SVGIcon = shapeLineIcon;

  previousUrl: string;
  direct: boolean = false;

  activatedRoute: ActivatedRoute;
  breadCrumbService: BreadCrumbService;
  navigator: Router;

  bName: string;

  obj: any;


  constructor() {
    this.activatedRoute = inject(ActivatedRoute);
    this.breadCrumbService = inject(BreadCrumbService);
    this.navigator = inject(Router);

    this.subscription = new Subject<boolean>();
  }

  init(obj?: any, propertyNames?: string[]): void {
    var breadCrumbPropertyNames: string[] = ["name"];

    if (propertyNames !== undefined && propertyNames.length > 0) {
      breadCrumbPropertyNames = propertyNames;
    }

    if (obj !== undefined && obj !== null) {
      this.obj = obj;
    }

    this.breadCrumbService.update(this.activatedRoute, this.bName, this.obj, breadCrumbPropertyNames, this.direct);
  }

  onBreadCrumbClicked(item: BreadCrumbItem): void {
    var bcs = this.breadCrumbService.getBreadCrumbs();
    var bc = bcs.filter(b => b.item.text == item.text)[0];
    if (bc) {
      this.navigator.navigate([bc.url]);
    }
  }

  ngOnDestroy(): void {
    this.subscription.next(true);
    this.subscription.unsubscribe();
  }

}
